import React, { useEffect, useState } from "react";
import SubHeader from "components/SubHeader";
import SubHeaderTitle from "components/SubHeader/SubHeaderTitle";
import SubHeaderBackButton from "components/SubHeader/SubHeaderBackButton";
import { useTranslation } from "react-i18next";
import { netCall } from "utils/netCall";
import { ManagementApiUrl } from "environment/routeSettings";
import { TApartment } from "types/dto";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { ApartmentInfo, TEditFormTypes } from "./components/ApartmentInfo";
import { RelatedWaterSubscribers } from "./components/RelatedWaterSubscribers";
import { TResponseCode } from "utils/netCall/types";

const ApartmentDetailsView = () => {
  const { t } = useTranslation();
  const { apartmentId } = useParams();

  const [isGettingData, setIsGettingData] = useState<boolean>(false);
  const [initData, setInitData] = useState<TApartment>();
  const [apartmentInfoSubmitting, setApartmentInfoSubmitting] = useState(false);
  const [enableEditing, setEnableEditing] = useState(false);

  const onSaveApartmentInfo = async (values: TEditFormTypes) => {
    setApartmentInfoSubmitting(true);
    const res = await netCall<TApartment>({
      method: "POST",
      endPoint: `${ManagementApiUrl()}/api/Apartment/UpdateApartment`,
      body: {
        id: initData?.id,
        ...values,
        latitude: values.location?.lat,
        longitude: values.location?.lng,
      },
    });
    if (res.responseCode === TResponseCode.OK) {
      setApartmentInfoSubmitting(false);
      toast.success(t("operationSuccessful"));
      await getApartmentDetails();
      setEnableEditing(false);
    } else {
      setApartmentInfoSubmitting(false);
      toast.error(t("operationFailed"));
    }
  };

  const getApartmentDetails = async () => {
    setIsGettingData(true);
    const res = await netCall<TApartment>({
      method: "GET",
      endPoint: `${ManagementApiUrl()}/api/Apartment/GetApartment/${apartmentId}`,
    });
    if (res.responseCode === TResponseCode.OK) {
      const record = res.results;
      setInitData(record);
    } else {
      toast.error(t("errorInGettingData"));
    }
    setIsGettingData(false);
  };

  useEffect(() => {
    if (apartmentId) {
      getApartmentDetails();
    }
  }, [apartmentId]);

  return (
    <>
      <SubHeader>
        <SubHeaderTitle>
          <SubHeaderBackButton />
          {t("apartmentDetails")}
        </SubHeaderTitle>
      </SubHeader>
      <div
        className={"flex flex-col grid-cols-3 gap-y-4 p-4 h-full overflow-auto"}
      >
        <div className="col-span-3">
          <ApartmentInfo
            data={initData}
            isLoading={isGettingData}
            onSaveClick={onSaveApartmentInfo}
            isButtonLoading={apartmentInfoSubmitting}
            onEditClick={() => setEnableEditing(true)}
            enableEditing={enableEditing}
          />
        </div>
        <div className="col-span-3">
          <RelatedWaterSubscribers
            data={initData?.waterSubscribers}
            isLoading={isGettingData}
          />
        </div>
      </div>
    </>
  );
};

export default ApartmentDetailsView;
